import request from './request';

const BASE = 'dashboard/admin/repairs';

const formDataConfig = { headers: { 'Content-Type': undefined } };

const repairService = {
  getAll: (params = {}) =>
    request.get(BASE, { params }),

  getById: (id) =>
    request.get(`${BASE}/${id}`),

  create: (data) => {
    const isFormData = data instanceof FormData;
    return request.post(BASE, data, isFormData ? formDataConfig : {});
  },

  /** PATCH details (any admin). Do not send status or userId here. */
  updateDetails: (id, body) =>
    request.patch(`${BASE}/${id}`, body),

  updateStatus: (id, status, note) =>
    request.patch(`${BASE}/${id}/update-status`, note ? { status, note } : { status }),

  addProofImages: (id, formData) =>
    request.post(`${BASE}/${id}/proof-images`, formData, formDataConfig),

  delete: (id) =>
    request.delete(`${BASE}/${id}`),
};

export default repairService;
